import React, { createContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

export const Context = createContext({});

const productData = {
  avatarUrl:
    'https://res.cloudinary.com/scall/image/upload/v1605648242/sCallProfiles/annie_bell/profile_pic_hair1_od3wuk.png',
  firstName: 'Annie',
  lastName: 'Bell',
  profession: 'Stylist @ Vanity Hair Studio',
  product: {
    productDescription:
      'This hydrating leave-in mist detangles and smooths flyaways, leaving strands soft, polished, and manageable',
    productTitle: 'Leave-In Conditioner',
    productPrice: '2500',
    productOriginalPrice: '4000',
    productImages: [
      {
        id: uuidv4(),
        url: 'https://prose.com/static/media/leavein_carousel_3.578af613.jpg',
      },
      {
        id: uuidv4(),
        url: 'https://prose.com/static/media/curlcream_carousel_3.230124cc.jpg',
      },
      {
        id: uuidv4(),
        url: 'https://prose.com/static/media/curlcream_carousel_3.230124cc.jpg',
      },
      {
        id: uuidv4(),
        url: 'https://prose.com/static/media/curlcream_carousel_3.230124cc.jpg',
      },
    ],
    colors: [
      { value: '#4B0082', label: 'indigo' },
      { value: '#008080', label: 'teal' },
      { value: '#00FF00', label: 'lime' },
      { value: '#FFA500', label: 'orange' },
      { value: '#FF0000', label: 'red' },
      { value: '#808080', label: 'grey' },
    ],
    sizes: [
      { value: 'XS', label: 'xs' },
      { value: 'S', label: 's' },
      { value: 'M', label: 'm' },
      { value: 'L', label: 'l' },
      { value: 'XL', label: 'xl' },
      { value: 'XXL', label: 'xxl' },
    ],
    minAmount: '0',
    maxAmount: '99',
    endDate: '01/11/2021',
  },
};

export const Provider = ({ children }) => {
  const contextData = {
    productData,
  };
  return <Context.Provider value={{ contextData }}>{children}</Context.Provider>;
};

export const { Consumer } = Context;

Provider.defaultProps = {};

Provider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
